import { TextField } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledEditor = styled(TextField)(({ theme }) => ({
  height: '100%',
  '& .MuiInputBase-root': {
    height: '100%',
    alignItems: 'flex-start',
    padding: '0 !important',
  },
  '& .MuiOutlinedInput-root': {
    borderRadius: 0,
    backgroundColor:
      theme.palette.mode === "dark"
        ? "#1a202c"
        : "#f8fafc",

    '& textarea': {
      padding: '16px',
      height: 'calc(100% - 32px) !important',
      overflowY: 'auto !important',
    },

    '& fieldset': {
      border: '1px solid rgba(0, 0, 0, 0.12)',
      '&:hover': {
        border: '1px solid rgba(0, 0, 0, 0.23)',
      },
      transition: 'border-color 0.2s',
    }
  },
  backgroundColor:
    theme.palette.mode === "dark"
      ? "#1a202c"
      : "#f8fafc",
}));

export default function Editor({ value, onChange }) {
  return (
    <StyledEditor
      multiline
      fullWidth
      value={value}
      onChange={(e) => onChange(e.target.value)}
      variant="outlined"
    />
  );
}